export const locators = {
  errorReq: 'login-form-req',
  errorPattern: 'login-form-pattern',
  errorServerGeneral: 'login-form-server-general',
  errorServerNotRegistered: 'login-form-server-not-registered',
  submitButton: 'login-form-submit-button',
}
